import { createClient } from '@supabase/supabase-js'
import { Database } from './database.types'
import { env } from '@/utils/env'

const supabaseUrl = env.VITE_SUPABASE_URL
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'crm-auth-storage',
  },
  db: {
    schema: 'public'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    },
    // Configurações para melhor resiliência
    heartbeatIntervalMs: 30000,
    reconnectAfterMs: (tries: number) => {
      return Math.min(1000 * 2 ** tries, 30000)
    }
  },
  global: {
    headers: {
      'x-application-name': 'crm-relacionamento-parceiro',
      'apikey': supabaseAnonKey
    },
    // Configurações de fetch para melhor resiliência
    fetch: (url, options = {}) => {
      return fetch(url, {
        ...options,
        // Aumentar timeout
        signal: AbortSignal.timeout(30000)
      })
    }
  }
})

// Helper function to get client IP (for logging)
export const getClientIP = async (): Promise<string | null> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json')
    const data = await response.json()
    return data.ip
  } catch {
    return null
  }
}

// Helper function to get user agent
export const getUserAgent = (): string => {
  return navigator.userAgent
}